export type StorageErrorCode =
  | 'unavailable'
  | 'not-found'
  | 'validation'
  | 'conflict'
  /** The cross-tab editing lock could not be taken (Web Locks failed); retryable. */
  | 'lock-failed'
  | 'quota'
  | 'transaction'
  | 'invalid-file';

/** Error type surfaced to the UI for every persistence/import failure. */
export class StorageError extends Error {
  readonly code: StorageErrorCode;
  readonly details: string[];
  constructor(code: StorageErrorCode, message: string, details: string[] = [], options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'StorageError';
    this.code = code;
    this.details = details;
  }
}

export function toStorageError(error: unknown, fallback = 'The storage operation failed.'): StorageError {
  if (error instanceof StorageError) return error;
  const name = (error as { name?: string } | null)?.name;
  if (name === 'QuotaExceededError') {
    return new StorageError('quota', 'Browser storage is full. Free some space or export and delete old projects.', [], {
      cause: error,
    });
  }
  const message = error instanceof Error && error.message ? `${fallback} (${error.message})` : fallback;
  return new StorageError('transaction', message, [], { cause: error });
}
